import React from 'react';
import StromaThemeProvider from './ThemeProvider';

/** The app's theme root: the simplified app's look (#1502). */
export default function AppThemeProvider({ children }: React.PropsWithChildren) {
  return <StromaThemeProvider>{children}</StromaThemeProvider>;
}
